import { TICKETS_LIMIT } from '@components/Results/Components/TicketsLeft/TicketsLeft';

export const isNullOrUndefined = (value) => !value;

export const isItineraryVisiblePrimeDayTab = (itinerary, sortBy) => {
  return (
    sortBy !== 'primeDay' ||
    itinerary.campaignConfig.primeDayConfig?.isPrimeDayFare
  );
};

export const shallShowTicketsLeft = (ticketsLeft) => {
  return ticketsLeft > TICKETS_LIMIT.MIN && ticketsLeft < TICKETS_LIMIT.MAX;
};
